import Agents from "../views/agents";
import DashBoard from "../views/DashBoard";
import Login from "../views/Login";
import Attendance from "../views/attendance";
import Visits from "../views/visits";
import AttendanceDetails from "../views/attendance/components/AttendanceDetails";
import FarmersList from "../views/Farmers/List";
import FarmerProfile from "../views/Farmers/FarmerDetails/Index";

export const routes = [
  {
    path: "/login",
    export: true,
    name: "login",
    component: Login,
  },
  {
    path: "/dashBoard",
    export: true,
    name: "DashBoard",
    component: DashBoard,
  },
  {
    path: "/agents",
    export: true,
    name: "Agents",
    component: Agents,
  },

  {
    path: "/attendance",
    export: true,
    name: "Attendance",
    component: Attendance,
  },

  {
    path: "/visits/:sessionId",
    export: true,
    name: "Visits",
    component: Visits,
  },

  {
    path: "/attendance/:employeeId",
    export: true,
    name: "Attendance Details",
    component: AttendanceDetails,
  },
      {
    path: "/farmerProfile",
    export: true,
    name: "FarmerProfile",
    component: FarmerProfile,
  },

      {
    path: "/farmers",
    export: true,
    name: "FarmersList",
    component: FarmersList,
  },
];
